import { SAVED_CART_LOAD_ERROR, SAVED_CART_LIST_RECEIVE } from '../Actions/SavedCart.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    savedCarts: [{}],
    selectedUserId: '',
    errors: {},
    updatedCartList: [],
    loadingStatus: 'Completed',
    showUpdateButton: false,
    selectedCart:{},
    cartId:null,
    selectedOrderName:null,
}

export const savedCart = (state = defaultState, action) => {

    switch (action.type) {
        case SAVED_CART_LIST_RECEIVE:
            return {
                ...state,
                ...action.payload

            };
        case SAVED_CART_LOAD_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}